export const DocumentUploadIcon = ({ theme, width, height }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 120 132"
        fill="none"
        width={width ? width : height ? height : 120}
        height={height ? height : width ? width : 132}
    >
        <path
            d="M101.95 91.9499C106.827 89.2913 110.679 85.0843 112.899 79.993C115.119 74.9018 115.581 69.2161 114.211 63.8334C112.841 58.4507 109.717 53.6775 105.333 50.2672C100.949 46.8568 95.5541 45.0036 89.9998 44.9999H83.6998C82.1864 39.1461 79.3656 33.7116 75.4496 29.1049C71.5335 24.4982 66.624 20.8392 61.0903 18.403C55.5566 15.9667 49.5426 14.8167 43.5004 15.0393C37.4582 15.2619 31.5451 16.8514 26.2057 19.6882C20.8662 22.5251 16.2394 26.5354 12.6729 31.4178C9.10646 36.3002 6.69325 41.9276 5.6147 47.8769C4.53615 53.8262 4.82033 59.9426 6.44587 65.7662C8.07141 71.5899 10.996 76.9692 14.9998 81.4999"
            stroke="#E89948"
            strokeWidth="5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M60 47V77" stroke="#E89948" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M74 59.5185L60 45L46 59.5185"
            stroke="#E89948"
            strokeWidth="5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <g opacity="0.4">
            <path
                d="M64.1668 85.959H47.5002C46.3951 85.959 45.3353 86.398 44.5539 87.1794C43.7725 87.9608 43.3335 89.0206 43.3335 90.1257V123.459C43.3335 124.564 43.7725 125.624 44.5539 126.405C45.3353 127.187 46.3951 127.626 47.5002 127.626H72.5002C73.6052 127.626 74.665 127.187 75.4464 126.405C76.2278 125.624 76.6668 124.564 76.6668 123.459V98.459L64.1668 85.959Z"
                stroke={theme === "dark" ? "white" : "black"}
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M64.1665 85.959V98.459H76.6665"
                stroke={theme === "dark" ? "white" : "black"}
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M68.3332 108.876H51.6665"
                stroke={theme === "dark" ? "white" : "black"}
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M68.3332 117.209H51.6665"
                stroke={theme === "dark" ? "white" : "black"}
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M55.8332 100.542H53.7498H51.6665"
                stroke={theme === "dark" ? "white" : "black"}
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
    </svg>
);
